import React from "react";
import Product from "../product/Product";
import TitleImageHeader from "../product/TitleImageHeader";
import {
    getProductHeaderWidth,
    getProductListSlidePerView,
    getProductListWidth,
    IsLP_MP_SP
} from "my-styles/media/media";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Navigation} from "swiper";
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

SwiperCore.use([Navigation])

export default function ImageProductList(props) {

    let header = props.header
    let products = props.products
    let backgroundColor = 'var(--gray)'
    if (header.backgroundColor) {
        backgroundColor = header.backgroundColor
    }
    let backgroundImage = ''
    if (header.backgroundImage) {
        backgroundImage = 'url(' + header.backgroundImage + ')'
    }

    function getLargeList() {
        const hasRelated = props.data && props.data.related_lines && props.data.related_lines.length > 0
        return (<div className="imageProductList"
                     style={{backgroundColor: backgroundColor, backgroundImage: backgroundImage}}>
            {props.dataType && props.dataType === "homeProductList" ? <div>
                <TitleImageHeader dataType={props.dataType} header={header} onAllClicked={props.onAllClicked}/>
            </div> : <div style={{width: getProductHeaderWidth(hasRelated)}}>
                <TitleImageHeader header={header} onAllClicked={props.onAllClicked}/>
            </div>}

            {(products && products.length) > 0 &&
                <div style={{minWidth: getProductListWidth(hasRelated)}}>
                    <Swiper
                        dir="rtl"
                        slidesPerView={getProductListSlidePerView(hasRelated, "0")}
                        spaceBetween={10}
                        navigation={true}
                        modules={[Navigation]}>
                        {products.map((product, index) => {
                            return <SwiperSlide key={index} className="marginSmall">
                                <div className="imageProduct">
                                    <Product {...props} data={product}/>
                                </div>
                            </SwiperSlide>
                        })}
                        <SwiperSlide style={{width: "1em"}}/>
                    </Swiper>
                </div>
            }
        </div>)
    }

    function getSmallList() {
        return (<div className="imageProductList HScrollInMobile"
                     style={{backgroundColor: backgroundColor, backgroundImage: backgroundImage}}>
            <div>
                {props.dataType && props.dataType === "homeProductList" ?
                    <TitleImageHeader
                        onAllClicked={props.onAllClicked}
                        dataType={props.dataType}
                        header={header}/> :
                    <TitleImageHeader
                        onAllClicked={props.onAllClicked}
                        header={header}/>
                }
            </div>
            <div className="horizontalScreen">
                {products.map((product, index) => {
                    return <div key={index} className="imageProduct">
                        <Product {...props} data={product}/>
                    </div>
                })}
            </div>
        </div>)
    }

    if (IsLP_MP_SP()) {
        return getLargeList()
    } else {
        return getSmallList()
    }

}